export const MODAL_VALUES_TABLE_ACTIVE = 'MODAL_VALUES_TABLE_ACTIVE';
export const MODAL_VALUES_LOADING = "MODAL_VALUES_LOADING";

export const MODAL_DOWNLOAD_PDF_START = 'MODAL_DOWNLOAD_PDF_START';
export const MODAL_DOWNLOAD_PDF_SUCCESS = 'MODAL_DOWNLOAD_PDF_SUCCESS';
export const MODAL_DOWNLOAD_PDF_FAIL = 'MODAL_DOWNLOAD_PDF_FAIL';
export const MODAL_GET_COBERTURAS = 'MODAL_GET_COBERTURAS';
export const MODAL_CLEAR = 'MODAL_CLEAR';
